import type { GetMeUserResponse } from "@nlc/shared-types";

import { USER_ROLES } from "@nlc/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { ConfidenceCheckerSummaryPage } from "@/features/request/confidence-checker-summary";

export const Route = createFileRoute(
  "/_auth/_app-shell/requests/$requestId/confidence-checker-summary",
)({
  beforeLoad: async ({ context, params }) => {
    const userData = context.queryClient.getQueryData<GetMeUserResponse>([
      "user",
    ]);

    const allowedRoles: string[] = [
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.TEAM_LEADER,
    ];

    if (
      !userData?.user?.roleName ||
      !allowedRoles.includes(userData.user.roleName)
    ) {
      throw redirect({
        to: `/requests/${params.requestId}/edit` as string,
      });
    }
  },
  component: ConfidenceCheckerSummaryPage,
});
